import React from "react";

import { ArrowIcon } from "components/atoms/Icons";

interface ExpandArrowsProps {
  onClick?: () => void;
  expanded?: boolean;
}
export const ExpandArrows = ({ expanded, onClick }: ExpandArrowsProps) => {
  return (
    <div
      className={`flex justify-center items-center w-8 h-8 cursor-pointer ${expanded ? "rotate-180" : ""}`}
      onClick={onClick}
    >
      <ArrowIcon />
    </div>
  );
};
